/**
 * WARNING: The order of each item in the lists may be used in conditional statements. Add new items at the end of the
 * array in order to not introduce unwanted behavior throughout the application.
 */

/**
 * Choices for distribution recalls for scheduled respondent form.
 */
const distroRecalls = [
	{
		displayText: 'Randomly distribute recalls per respondent across all days of the week',
		value: 'random'
	},
	{
		displayText: 'Specify the number of weekend recalls per respondent',
		value: 'specify'
	}
];

/**
 * Choices for number of days between recalls
 */
const daysBetween = [
	{
		displayText: 'Monthly (30 days)',
		value: '30'
	},
	{
		displayText: 'Bi-Weekly (14 days)',
		value: '14'
	},
	{
		displayText: 'Weekly (7 days)',
		value: '7'
	},
	{
		displayText: 'Range – _ to __ days',
		value: 'range'
	},
	{
		displayText: 'Custom _ (enter one number of days between)',
		value: 'custom'
	}
];

/**
 * Choices for number of days between attempts
 */
const daysBetweenAttemptChoices = [
	{
		displayText: 'Specify number of days between',
		value: 'specific'
	},
	{
		displayText: 'Specify range of days between',
		value: 'range'
	}
];

/**
 * Choices for respondent recall schedules
 */
const stagesOptions = [
	{
		displayText: 'Have all respondents start on the same date: (First possible day is tomorrow)',
		value: 'same'
	},
	{
		displayText: 'Have respondents start in stages. The system will evenly distribute the total number of respondents in the study among all the stages specified.',
		value: 'different'
	}
];

/**
 * Choices for how the passwords will be generated
 */
const passwordOptions = [
	{
		displayText: 'Provide a root word (4-6 characters)',
		value: 'root'
	},
	{
		displayText: 'System generated password',
		value: 'system'
	}
];

const WIZARD_TYPE_SCHEDULED = { key: 'Scheduled', value: 'SCHEDULED' };
const WIZARD_TYPE_UNSCHEDULED = { key: 'Unscheduled', value: 'UNSCHEDULED' };
const WIZARD_TYPE_RECORD = { key: 'Record', value: 'RECORD' };

const wizardTypeList = [WIZARD_TYPE_SCHEDULED, WIZARD_TYPE_UNSCHEDULED, WIZARD_TYPE_RECORD];

export default {
	distroRecalls,
	daysBetween,
	stagesOptions,
	passwordOptions,
	daysBetweenAttemptChoices,
	wizardTypeList,
	WIZARD_TYPE_SCHEDULED,
	WIZARD_TYPE_UNSCHEDULED,
	WIZARD_TYPE_RECORD
}
